import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebaseconf';
import {
    doc, setDoc, collection, addDoc, serverTimestamp
} from 'firebase/firestore';
import {
    Container, Box, Typography, Button, Alert, LinearProgress,
    Card, CardContent, Divider, Chip
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { createUserRoleDocument } from '../utils/authUtils';

// ============================================================
// ALL DEMO DATA - DIPLOMA ENGINEERING COLLEGE INDIA
// ============================================================
const INSTITUTION_ID = 'inst_mec_polytechnic_001';

const INSTITUTION = {
    name: 'Metropolitan Engineering College',
    type: 'polytechnic',
    email: 'info@meteng.edu.in',
    phone: '+91-11-4444-5678',
    subscription_status: 'active',
    subscription_plan: 'professional',
    address: 'Delhi Road, Industrial Area Phase-2',
    city: 'Gurgaon',
    state: 'Haryana',
    country: 'India',
    established_year: 2008,
    total_students: 180,
    total_teachers: 35,
    total_classes: 12,
    createdAt: new Date('2024-01-01'),
    affiliation: 'SCTE&VT, Haryana',
    accreditation: 'NAAC Accredited',
    principal: 'Prof. Dr. Rajesh Kumar',
    current_users: 26,
    max_users: 1000,
    current_storage_gb: 2.5,
    max_storage_gb: 100,
};

const USERS_TO_CREATE = [
    // Admin
    {
        email: 'admin@meteng.edu.in',
        password: 'AdminPass@123',
        name: 'Dr. Rajesh Kumar',
        first_name: 'Rajesh',
        last_name: 'Kumar',
        phone: '+91-98765-43210',
        role: 'admin',
        position: 'Principal',
        status: 'active',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        avatar: 'https://i.pravatar.cc/150?img=30',
        collection: 'users',
        docId: 'user_admin_001',
    },
    // Teachers - CSE Branch
    {
        email: 'priya.sharma@meteng.edu.in',
        password: 'TPassword@123',
        name: 'Ms. Priya Sharma',
        first_name: 'Priya',
        last_name: 'Sharma',
        phone: '+91-98765-11111',
        role: 'teacher',
        status: 'active',
        subjects: ['Data Structures', 'Programming Fundamentals'],
        branch: 'CSE',
        classes: ['CSE-1A', 'CSE-1B'],
        qualification: 'B.Tech (CSE) + M.Tech (Software Engineering)',
        experience_years: 12,
        department: 'Computer Science Engineering',
        avatar: 'https://i.pravatar.cc/150?img=1',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'teachers',
        docId: 'teacher_cse_001',
    },
    // Teachers - Civil Engineering
    {
        email: 'amit.verma@meteng.edu.in',
        password: 'TPassword@123',
        name: 'Mr. Amit Verma',
        first_name: 'Amit',
        last_name: 'Verma',
        phone: '+91-98765-22222',
        role: 'teacher',
        status: 'active',
        subjects: ['Surveying', 'Building Construction'],
        branch: 'CE',
        classes: ['CE-1A', 'CE-1B'],
        qualification: 'Diploma (Civil) + B.Tech (Civil Engineering)',
        experience_years: 10,
        department: 'Civil Engineering',
        avatar: 'https://i.pravatar.cc/150?img=2',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'teachers',
        docId: 'teacher_ce_001',
    },
    // Teachers - Electrical Engineering
    {
        email: 'suresh.patel@meteng.edu.in',
        password: 'TPassword@123',
        name: 'Mr. Suresh Patel',
        first_name: 'Suresh',
        last_name: 'Patel',
        phone: '+91-98765-33333',
        role: 'teacher',
        status: 'active',
        subjects: ['Electrical Machines', 'Power Systems'],
        branch: 'EE',
        classes: ['EE-1A', 'EE-1B'],
        qualification: 'Diploma (Electrical) + B.Tech (Electrical)',
        experience_years: 15,
        department: 'Electrical Engineering',
        avatar: 'https://i.pravatar.cc/150?img=3',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'teachers',
        docId: 'teacher_ee_001',
    },
    // Teachers - Electronics & Communication
    {
        email: 'neha.gupta@meteng.edu.in',
        password: 'TPassword@123',
        name: 'Ms. Neha Gupta',
        first_name: 'Neha',
        last_name: 'Gupta',
        phone: '+91-98765-44444',
        role: 'teacher',
        status: 'active',
        subjects: ['Digital Electronics', 'Communication Systems'],
        branch: 'ECE',
        classes: ['ECE-1A', 'ECE-2A'],
        qualification: 'Diploma (ECE) + B.Tech (Electronics)',
        experience_years: 9,
        department: 'Electronics & Communication Engineering',
        avatar: 'https://i.pravatar.cc/150?img=4',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'teachers',
        docId: 'teacher_ece_001',
    },
    // Teachers - Mechanical Engineering
    {
        email: 'rajesh.singh@meteng.edu.in',
        password: 'TPassword@123',
        name: 'Mr. Rajesh Singh',
        first_name: 'Rajesh',
        last_name: 'Singh',
        phone: '+91-98765-55555',
        role: 'teacher',
        status: 'active',
        subjects: ['Thermodynamics', 'Mechanical Design'],
        branch: 'ME',
        classes: ['ME-1A', 'ME-1B'],
        qualification: 'Diploma (Mechanical) + B.Tech (Mechanical)',
        experience_years: 14,
        department: 'Mechanical Engineering',
        avatar: 'https://i.pravatar.cc/150?img=5',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'teachers',
        docId: 'teacher_me_001',
    },
    // Teachers - Information Technology
    {
        email: 'aditi.kapoor@meteng.edu.in',
        password: 'TPassword@123',
        name: 'Ms. Aditi Kapoor',
        first_name: 'Aditi',
        last_name: 'Kapoor',
        phone: '+91-98765-66666',
        role: 'teacher',
        status: 'active',
        subjects: ['Database Management', 'Web Technologies'],
        branch: 'IT',
        classes: ['IT-1A', 'IT-2B'],
        qualification: 'Diploma (IT) + B.Tech (IT)',
        experience_years: 8,
        department: 'Information Technology',
        avatar: 'https://i.pravatar.cc/150?img=6',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'teachers',
        docId: 'teacher_it_001',
    },
    // ===== STUDENTS CSE =====
    {
        email: 'raj.patel@student.com',
        password: 'SPassword@123',
        name: 'Raj Patel',
        first_name: 'Raj',
        last_name: 'Patel',
        roll_number: 'CSE-001',
        phone: '+91-98765-51001',
        role: 'student',
        status: 'active',
        class: 'CSE-1A',
        branch: 'CSE',
        section: 'A',
        admission_number: 'ADM-2024-CSE-001',
        father_name: 'Vikram Patel',
        father_phone: '+91-98765-91001',
        date_of_birth: '2006-05-15',
        avatar: 'https://i.pravatar.cc/150?img=21',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_cse_001',
    },
    {
        email: 'priyanka.singh@student.com',
        password: 'SPassword@123',
        name: 'Priyanka Singh',
        first_name: 'Priyanka',
        last_name: 'Singh',
        roll_number: 'CSE-002',
        phone: '+91-98765-51002',
        role: 'student',
        status: 'active',
        class: 'CSE-1A',
        branch: 'CSE',
        section: 'A',
        admission_number: 'ADM-2024-CSE-002',
        father_name: 'Arun Singh',
        father_phone: '+91-98765-91002',
        date_of_birth: '2006-08-20',
        avatar: 'https://i.pravatar.cc/150?img=22',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_cse_002',
    },
    {
        email: 'arjun.verma@student.com',
        password: 'SPassword@123',
        name: 'Arjun Verma',
        first_name: 'Arjun',
        last_name: 'Verma',
        roll_number: 'CSE-003',
        phone: '+91-98765-51003',
        role: 'student',
        status: 'active',
        class: 'CSE-1B',
        branch: 'CSE',
        section: 'B',
        admission_number: 'ADM-2024-CSE-003',
        father_name: 'Manoj Verma',
        father_phone: '+91-98765-91003',
        date_of_birth: '2006-03-10',
        avatar: 'https://i.pravatar.cc/150?img=23',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_cse_003',
    },
    // ===== STUDENTS CIVIL ENGINEERING =====
    {
        email: 'nikhil.sharma@student.com',
        password: 'SPassword@123',
        name: 'Nikhil Sharma',
        first_name: 'Nikhil',
        last_name: 'Sharma',
        roll_number: 'CE-001',
        phone: '+91-98765-52001',
        role: 'student',
        status: 'active',
        class: 'CE-1A',
        branch: 'CE',
        section: 'A',
        admission_number: 'ADM-2024-CE-001',
        father_name: 'Ravi Sharma',
        father_phone: '+91-98765-92001',
        date_of_birth: '2006-07-22',
        avatar: 'https://i.pravatar.cc/150?img=24',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ce_001',
    },
    {
        email: 'pooja.reddy@student.com',
        password: 'SPassword@123',
        name: 'Pooja Reddy',
        first_name: 'Pooja',
        last_name: 'Reddy',
        roll_number: 'CE-002',
        phone: '+91-98765-52002',
        role: 'student',
        status: 'active',
        class: 'CE-1B',
        branch: 'CE',
        section: 'B',
        admission_number: 'ADM-2024-CE-002',
        father_name: 'Krishna Reddy',
        father_phone: '+91-98765-92002',
        date_of_birth: '2006-09-05',
        avatar: 'https://i.pravatar.cc/150?img=25',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ce_002',
    },
    {
        email: 'deepak.gautam@student.com',
        password: 'SPassword@123',
        name: 'Deepak Gautam',
        first_name: 'Deepak',
        last_name: 'Gautam',
        roll_number: 'CE-003',
        phone: '+91-98765-52003',
        role: 'student',
        status: 'active',
        class: 'CE-1A',
        branch: 'CE',
        section: 'A',
        admission_number: 'ADM-2024-CE-003',
        father_name: 'Sunil Gautam',
        father_phone: '+91-98765-92003',
        date_of_birth: '2006-04-18',
        avatar: 'https://i.pravatar.cc/150?img=26',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ce_003',
    },
    // ===== STUDENTS ELECTRICAL ENGINEERING =====
    {
        email: 'vikram.nair@student.com',
        password: 'SPassword@123',
        name: 'Vikram Nair',
        first_name: 'Vikram',
        last_name: 'Nair',
        roll_number: 'EE-001',
        phone: '+91-98765-53001',
        role: 'student',
        status: 'active',
        class: 'EE-1A',
        branch: 'EE',
        section: 'A',
        admission_number: 'ADM-2024-EE-001',
        father_name: 'Suresh Nair',
        father_phone: '+91-98765-93001',
        date_of_birth: '2006-02-14',
        avatar: 'https://i.pravatar.cc/150?img=27',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ee_001',
    },
    {
        email: 'riya.mishra@student.com',
        password: 'SPassword@123',
        name: 'Riya Mishra',
        first_name: 'Riya',
        last_name: 'Mishra',
        roll_number: 'EE-002',
        phone: '+91-98765-53002',
        role: 'student',
        status: 'active',
        class: 'EE-1B',
        branch: 'EE',
        section: 'B',
        admission_number: 'ADM-2024-EE-002',
        father_name: 'Neeraj Mishra',
        father_phone: '+91-98765-93002',
        date_of_birth: '2006-06-25',
        avatar: 'https://i.pravatar.cc/150?img=28',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ee_002',
    },
    {
        email: 'saurav.kumar@student.com',
        password: 'SPassword@123',
        name: 'Saurav Kumar',
        first_name: 'Saurav',
        last_name: 'Kumar',
        roll_number: 'EE-003',
        phone: '+91-98765-53003',
        role: 'student',
        status: 'active',
        class: 'EE-1A',
        branch: 'EE',
        section: 'A',
        admission_number: 'ADM-2024-EE-003',
        father_name: 'Rajesh Kumar',
        father_phone: '+91-98765-93003',
        date_of_birth: '2006-11-30',
        avatar: 'https://i.pravatar.cc/150?img=29',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ee_003',
    },
    // ===== STUDENTS ELECTRONICS & COMMUNICATION =====
    {
        email: 'anjali.negi@student.com',
        password: 'SPassword@123',
        name: 'Anjali Negi',
        first_name: 'Anjali',
        last_name: 'Negi',
        roll_number: 'ECE-001',
        phone: '+91-98765-54001',
        role: 'student',
        status: 'active',
        class: 'ECE-1A',
        branch: 'ECE',
        section: 'A',
        admission_number: 'ADM-2024-ECE-001',
        father_name: 'Abhay Negi',
        father_phone: '+91-98765-94001',
        date_of_birth: '2006-08-12',
        avatar: 'https://i.pravatar.cc/150?img=31',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ece_001',
    },
    {
        email: 'raman.singh@student.com',
        password: 'SPassword@123',
        name: 'Raman Singh',
        first_name: 'Raman',
        last_name: 'Singh',
        roll_number: 'ECE-002',
        phone: '+91-98765-54002',
        role: 'student',
        status: 'active',
        class: 'ECE-2A',
        branch: 'ECE',
        section: 'A',
        admission_number: 'ADM-2024-ECE-002',
        father_name: 'Vinod Singh',
        father_phone: '+91-98765-94002',
        date_of_birth: '2005-05-02',
        avatar: 'https://i.pravatar.cc/150?img=32',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ece_002',
    },
    {
        email: 'meera.singh@student.com',
        password: 'SPassword@123',
        name: 'Meera Singh',
        first_name: 'Meera',
        last_name: 'Singh',
        roll_number: 'ECE-003',
        phone: '+91-98765-54003',
        role: 'student',
        status: 'active',
        class: 'ECE-1A',
        branch: 'ECE',
        section: 'A',
        admission_number: 'ADM-2024-ECE-003',
        father_name: 'Shekhar Singh',
        father_phone: '+91-98765-94003',
        date_of_birth: '2006-10-15',
        avatar: 'https://i.pravatar.cc/150?img=33',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_ece_003',
    },
    // ===== STUDENTS MECHANICAL ENGINEERING =====
    {
        email: 'arun.desai@student.com',
        password: 'SPassword@123',
        name: 'Arun Desai',
        first_name: 'Arun',
        last_name: 'Desai',
        roll_number: 'ME-001',
        phone: '+91-98765-55001',
        role: 'student',
        status: 'active',
        class: 'ME-1A',
        branch: 'ME',
        section: 'A',
        admission_number: 'ADM-2024-ME-001',
        father_name: 'Vishal Desai',
        father_phone: '+91-98765-95001',
        date_of_birth: '2006-01-08',
        avatar: 'https://i.pravatar.cc/150?img=34',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_me_001',
    },
    {
        email: 'sneha.srivastava@student.com',
        password: 'SPassword@123',
        name: 'Sneha Srivastava',
        first_name: 'Sneha',
        last_name: 'Srivastava',
        roll_number: 'ME-002',
        phone: '+91-98765-55002',
        role: 'student',
        status: 'active',
        class: 'ME-1B',
        branch: 'ME',
        section: 'B',
        admission_number: 'ADM-2024-ME-002',
        father_name: 'Kiran Srivastava',
        father_phone: '+91-98765-95002',
        date_of_birth: '2006-03-20',
        avatar: 'https://i.pravatar.cc/150?img=35',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_me_002',
    },
    {
        email: 'harsh.dubey@student.com',
        password: 'SPassword@123',
        name: 'Harsh Dubey',
        first_name: 'Harsh',
        last_name: 'Dubey',
        roll_number: 'ME-003',
        phone: '+91-98765-55003',
        role: 'student',
        status: 'active',
        class: 'ME-1A',
        branch: 'ME',
        section: 'A',
        admission_number: 'ADM-2024-ME-003',
        father_name: 'Ashok Dubey',
        father_phone: '+91-98765-95003',
        date_of_birth: '2006-09-09',
        avatar: 'https://i.pravatar.cc/150?img=36',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_me_003',
    },
    // ===== STUDENTS INFORMATION TECHNOLOGY =====
    {
        email: 'akshay.kulkarni@student.com',
        password: 'SPassword@123',
        name: 'Akshay Kulkarni',
        first_name: 'Akshay',
        last_name: 'Kulkarni',
        roll_number: 'IT-001',
        phone: '+91-98765-56001',
        role: 'student',
        status: 'active',
        class: 'IT-1A',
        branch: 'IT',
        section: 'A',
        admission_number: 'ADM-2024-IT-001',
        father_name: 'Sandeep Kulkarni',
        father_phone: '+91-98765-96001',
        date_of_birth: '2006-05-16',
        avatar: 'https://i.pravatar.cc/150?img=37',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_it_001',
    },
    {
        email: 'disha.maurya@student.com',
        password: 'SPassword@123',
        name: 'Disha Maurya',
        first_name: 'Disha',
        last_name: 'Maurya',
        roll_number: 'IT-002',
        phone: '+91-98765-56002',
        role: 'student',
        status: 'active',
        class: 'IT-2B',
        branch: 'IT',
        section: 'B',
        admission_number: 'ADM-2024-IT-002',
        father_name: 'Ashish Maurya',
        father_phone: '+91-98765-96002',
        date_of_birth: '2005-07-28',
        avatar: 'https://i.pravatar.cc/150?img=38',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_it_002',
    },
    {
        email: 'rohit.yadav@student.com',
        password: 'SPassword@123',
        name: 'Rohit Yadav',
        first_name: 'Rohit',
        last_name: 'Yadav',
        roll_number: 'IT-003',
        phone: '+91-98765-56003',
        role: 'student',
        status: 'active',
        class: 'IT-1A',
        branch: 'IT',
        section: 'A',
        admission_number: 'ADM-2024-IT-003',
        father_name: 'Rajesh Yadav',
        father_phone: '+91-98765-96003',
        date_of_birth: '2006-12-11',
        avatar: 'https://i.pravatar.cc/150?img=39',
        institution_id: INSTITUTION_ID,
        institution_name: 'Metropolitan Engineering College',
        collection: 'students',
        docId: 'student_it_003',
    },
];

// ===== Login Credentials for Demo =====
// Admin:   admin@meteng.edu.in / AdminPass@123
// Teacher (CSE):   priya.sharma@meteng.edu.in / TPassword@123
// Teacher (CE):    amit.verma@meteng.edu.in / TPassword@123
// Teacher (EE):    suresh.patel@meteng.edu.in / TPassword@123
// Teacher (ECE):   neha.gupta@meteng.edu.in / TPassword@123
// Teacher (ME):    rajesh.singh@meteng.edu.in / TPassword@123
// Teacher (IT):    aditi.kapoor@meteng.edu.in / TPassword@123
// Student (CSE):   raj.patel@student.com / SPassword@123
// Student (CE):    nikhil.sharma@student.com / SPassword@123
// Student (EE):    vikram.nair@student.com / SPassword@123
// Student (ECE):   anjali.negi@student.com / SPassword@123
// Student (ME):    arun.desai@student.com / SPassword@123
// Student (IT):    akshay.kulkarni@student.com / SPassword@123

const CLASSES = [
    // CSE 1st Semester
    { id: 'class_cse1a', name: 'CSE-1A', branch: 'CSE', semester: '1', section: 'A', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', total_students: 30, room_number: 'CSE-101', timing: '9:00 AM - 1:00 PM' },
    { id: 'class_cse1b', name: 'CSE-1B', branch: 'CSE', semester: '1', section: 'B', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', total_students: 30, room_number: 'CSE-102', timing: '1:00 PM - 5:00 PM' },
    // Civil Engineering 1st Semester
    { id: 'class_ce1a', name: 'CE-1A', branch: 'CE', semester: '1', section: 'A', teacher_id: 'teacher_ce_001', teacher_name: 'Mr. Amit Verma', total_students: 30, room_number: 'CE-201', timing: '9:00 AM - 1:00 PM' },
    { id: 'class_ce1b', name: 'CE-1B', branch: 'CE', semester: '1', section: 'B', teacher_id: 'teacher_ce_001', teacher_name: 'Mr. Amit Verma', total_students: 30, room_number: 'CE-202', timing: '1:00 PM - 5:00 PM' },
    // Electrical Engineering 1st Semester
    { id: 'class_ee1a', name: 'EE-1A', branch: 'EE', semester: '1', section: 'A', teacher_id: 'teacher_ee_001', teacher_name: 'Mr. Suresh Patel', total_students: 30, room_number: 'EE-301', timing: '9:00 AM - 1:00 PM' },
    { id: 'class_ee1b', name: 'EE-1B', branch: 'EE', semester: '1', section: 'B', teacher_id: 'teacher_ee_001', teacher_name: 'Mr. Suresh Patel', total_students: 30, room_number: 'EE-302', timing: '1:00 PM - 5:00 PM' },
    // ECE 1st & 2nd Semester
    { id: 'class_ece1a', name: 'ECE-1A', branch: 'ECE', semester: '1', section: 'A', teacher_id: 'teacher_ece_001', teacher_name: 'Ms. Neha Gupta', total_students: 30, room_number: 'ECE-401', timing: '9:00 AM - 1:00 PM' },
    { id: 'class_ece2a', name: 'ECE-2A', branch: 'ECE', semester: '2', section: 'A', teacher_id: 'teacher_ece_001', teacher_name: 'Ms. Neha Gupta', total_students: 30, room_number: 'ECE-402', timing: '1:00 PM - 5:00 PM' },
    // Mechanical Engineering 1st Semester
    { id: 'class_me1a', name: 'ME-1A', branch: 'ME', semester: '1', section: 'A', teacher_id: 'teacher_me_001', teacher_name: 'Mr. Rajesh Singh', total_students: 30, room_number: 'ME-501', timing: '9:00 AM - 1:00 PM' },
    { id: 'class_me1b', name: 'ME-1B', branch: 'ME', semester: '1', section: 'B', teacher_id: 'teacher_me_001', teacher_name: 'Mr. Rajesh Singh', total_students: 30, room_number: 'ME-502', timing: '1:00 PM - 5:00 PM' },
    // Information Technology 1st & 2nd Semester
    { id: 'class_it1a', name: 'IT-1A', branch: 'IT', semester: '1', section: 'A', teacher_id: 'teacher_it_001', teacher_name: 'Ms. Aditi Kapoor', total_students: 30, room_number: 'IT-601', timing: '9:00 AM - 1:00 PM' },
    { id: 'class_it2b', name: 'IT-2B', branch: 'IT', semester: '2', section: 'B', teacher_id: 'teacher_it_001', teacher_name: 'Ms. Aditi Kapoor', total_students: 30, room_number: 'IT-602', timing: '1:00 PM - 5:00 PM' },
];

const SUBJECTS = [
    // CSE Subjects
    { id: 'subj_cse_001', name: 'Programming Fundamentals', code: 'CSE-101', branch: 'CSE', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_cse_002', name: 'Data Structures', code: 'CSE-102', branch: 'CSE', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_cse_003', name: 'Database Management Systems', code: 'CSE-201', branch: 'CSE', credits: 4, semester: '2', total_marks: 100 },
    { id: 'subj_cse_004', name: 'Web Technologies', code: 'CSE-202', branch: 'CSE', credits: 4, semester: '2', total_marks: 100 },
    // CE Subjects
    { id: 'subj_ce_001', name: 'Surveying', code: 'CE-101', branch: 'CE', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_ce_002', name: 'Building Construction', code: 'CE-102', branch: 'CE', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_ce_003', name: 'Hydraulics', code: 'CE-201', branch: 'CE', credits: 4, semester: '2', total_marks: 100 },
    { id: 'subj_ce_004', name: 'Structural Analysis', code: 'CE-202', branch: 'CE', credits: 4, semester: '2', total_marks: 100 },
    // EE Subjects
    { id: 'subj_ee_001', name: 'Electrical Machines', code: 'EE-101', branch: 'EE', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_ee_002', name: 'Power Systems', code: 'EE-102', branch: 'EE', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_ee_003', name: 'Electrical Measurements', code: 'EE-201', branch: 'EE', credits: 4, semester: '2', total_marks: 100 },
    { id: 'subj_ee_004', name: 'Power Electronics', code: 'EE-202', branch: 'EE', credits: 4, semester: '2', total_marks: 100 },
    // ECE Subjects
    { id: 'subj_ece_001', name: 'Digital Electronics', code: 'ECE-101', branch: 'ECE', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_ece_002', name: 'Communication Systems', code: 'ECE-102', branch: 'ECE', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_ece_003', name: 'Analog Electronics', code: 'ECE-201', branch: 'ECE', credits: 4, semester: '2', total_marks: 100 },
    { id: 'subj_ece_004', name: 'Microprocessors', code: 'ECE-202', branch: 'ECE', credits: 4, semester: '2', total_marks: 100 },
    // ME Subjects
    { id: 'subj_me_001', name: 'Thermodynamics', code: 'ME-101', branch: 'ME', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_me_002', name: 'Mechanical Design', code: 'ME-102', branch: 'ME', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_me_003', name: 'Heat Transfer', code: 'ME-201', branch: 'ME', credits: 4, semester: '2', total_marks: 100 },
    { id: 'subj_me_004', name: 'Fluid Mechanics', code: 'ME-202', branch: 'ME', credits: 4, semester: '2', total_marks: 100 },
    // IT Subjects
    { id: 'subj_it_001', name: 'Database Management', code: 'IT-101', branch: 'IT', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_it_002', name: 'Web Technologies', code: 'IT-102', branch: 'IT', credits: 4, semester: '1', total_marks: 100 },
    { id: 'subj_it_003', name: 'Advanced Database', code: 'IT-201', branch: 'IT', credits: 4, semester: '2', total_marks: 100 },
    { id: 'subj_it_004', name: 'Cloud Computing', code: 'IT-202', branch: 'IT', credits: 4, semester: '2', total_marks: 100 },
];

const ASSIGNMENTS = [
    // CSE Assignments
    { id: 'assign_cse_001', title: 'C Programming: Array Operations', description: 'Write C programs to perform various array operations including sorting, searching, and manipulation using classic algorithms.', subject: 'Programming Fundamentals', branch: 'CSE', semester: '1', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    { id: 'assign_cse_002', title: 'Data Structures: Linked List Implementation', description: 'Implement singly and doubly linked lists with operations like insert, delete, reverse, and display.', subject: 'Data Structures', branch: 'CSE', semester: '1', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', dueDate: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    // CE Assignments
    { id: 'assign_ce_001', title: 'Surveying Field Work Report', description: 'Prepare a detailed surveying field work report including measurements, calculations, and plan drawings.', subject: 'Surveying', branch: 'CE', semester: '1', teacher_id: 'teacher_ce_001', teacher_name: 'Mr. Amit Verma', dueDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    { id: 'assign_ce_002', title: 'Building Design Project', description: 'Design a commercial building layout including floor plans, elevations, and structural details.', subject: 'Building Construction', branch: 'CE', semester: '1', teacher_id: 'teacher_ce_001', teacher_name: 'Mr. Amit Verma', dueDate: new Date(Date.now() + 21 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    // EE Assignments
    { id: 'assign_ee_001', title: 'Electrical Machines Lab Report', description: 'Laboratory experiments on DC and AC machines with detailed observations, calculations, and conclusions.', subject: 'Electrical Machines', branch: 'EE', semester: '1', teacher_id: 'teacher_ee_001', teacher_name: 'Mr. Suresh Patel', dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    { id: 'assign_ee_002', title: 'Power Systems Analysis', description: 'Analyze transmission lines, load flow calculations, and power factor correction calculations.', subject: 'Power Systems', branch: 'EE', semester: '1', teacher_id: 'teacher_ee_001', teacher_name: 'Mr. Suresh Patel', dueDate: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    // ECE Assignments
    { id: 'assign_ece_001', title: 'Digital Logic Design Circuit', description: 'Design and simulate digital circuits using logic gates, multiplexers, decoders, and flip-flops.', subject: 'Digital Electronics', branch: 'ECE', semester: '1', teacher_id: 'teacher_ece_001', teacher_name: 'Ms. Neha Gupta', dueDate: new Date(Date.now() + 9 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    { id: 'assign_ece_002', title: 'Modulation Techniques Project', description: 'Study and implement AM, FM, and PSK modulation techniques with signal analysis.', subject: 'Communication Systems', branch: 'ECE', semester: '1', teacher_id: 'teacher_ece_001', teacher_name: 'Ms. Neha Gupta', dueDate: new Date(Date.now() + 12 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    // ME Assignments
    { id: 'assign_me_001', title: 'Thermodynamic Cycles Analysis', description: 'Analyze Otto, Diesel, and Brayton cycles with calculations for efficiency and work.', subject: 'Thermodynamics', branch: 'ME', semester: '1', teacher_id: 'teacher_me_001', teacher_name: 'Mr. Rajesh Singh', dueDate: new Date(Date.now() + 8 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    { id: 'assign_me_002', title: 'Mechanical Design Project', description: 'Design a simple mechanical system (gearbox, pulley system) with stress analysis.', subject: 'Mechanical Design', branch: 'ME', semester: '1', teacher_id: 'teacher_me_001', teacher_name: 'Mr. Rajesh Singh', dueDate: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    // IT Assignments
    { id: 'assign_it_001', title: 'Database Design & Normalization', description: 'Design a normalized database for a specific application with proper schema and relationships.', subject: 'Database Management', branch: 'IT', semester: '1', teacher_id: 'teacher_it_001', teacher_name: 'Ms. Aditi Kapoor', dueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
    { id: 'assign_it_002', title: 'Responsive Web Design Project', description: 'Create a responsive website using HTML5, CSS3, and JavaScript demonstrating modern web standards.', subject: 'Web Technologies', branch: 'IT', semester: '1', teacher_id: 'teacher_it_001', teacher_name: 'Ms. Aditi Kapoor', dueDate: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], total_marks: 50, status: 'active' },
];

const MARKS_DATA = [
    // CSE Students Marks
    { student_id: 'student_cse_001', student_name: 'Raj Patel', class: 'CSE-1A', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 85, total_marks: 100, percentage: 85, grade: 'A+', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_cse_001', student_name: 'Raj Patel', class: 'CSE-1A', branch: 'CSE', subject: 'Data Structures', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 92, total_marks: 100, percentage: 92, grade: 'A+', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_cse_002', student_name: 'Priyanka Singh', class: 'CSE-1A', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 78, total_marks: 100, percentage: 78, grade: 'B+', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_cse_002', student_name: 'Priyanka Singh', class: 'CSE-1A', branch: 'CSE', subject: 'Data Structures', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 82, total_marks: 100, percentage: 82, grade: 'A', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_cse_003', student_name: 'Arjun Verma', class: 'CSE-1B', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 88, total_marks: 100, percentage: 88, grade: 'A+', teacher_id: 'teacher_cse_001', teacher_name: 'Ms. Priya Sharma', status: 'submitted', date: '2024-09-30' },
    // CE Students Marks
    { student_id: 'student_ce_001', student_name: 'Nikhil Sharma', class: 'CE-1A', branch: 'CE', subject: 'Surveying', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 80, total_marks: 100, percentage: 80, grade: 'A', teacher_id: 'teacher_ce_001', teacher_name: 'Mr. Amit Verma', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_ce_001', student_name: 'Nikhil Sharma', class: 'CE-1A', branch: 'CE', subject: 'Building Construction', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 75, total_marks: 100, percentage: 75, grade: 'B+', teacher_id: 'teacher_ce_001', teacher_name: 'Mr. Amit Verma', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_ce_002', student_name: 'Pooja Reddy', class: 'CE-1B', branch: 'CE', subject: 'Surveying', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 86, total_marks: 100, percentage: 86, grade: 'A+', teacher_id: 'teacher_ce_001', teacher_name: 'Mr. Amit Verma', status: 'submitted', date: '2024-09-30' },
    // EE Students Marks
    { student_id: 'student_ee_001', student_name: 'Vikram Nair', class: 'EE-1A', branch: 'EE', subject: 'Electrical Machines', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 81, total_marks: 100, percentage: 81, grade: 'A', teacher_id: 'teacher_ee_001', teacher_name: 'Mr. Suresh Patel', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_ee_001', student_name: 'Vikram Nair', class: 'EE-1A', branch: 'EE', subject: 'Power Systems', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 79, total_marks: 100, percentage: 79, grade: 'B+', teacher_id: 'teacher_ee_001', teacher_name: 'Mr. Suresh Patel', status: 'submitted', date: '2024-09-30' },
    // ECE Students Marks
    { student_id: 'student_ece_001', student_name: 'Anjali Negi', class: 'ECE-1A', branch: 'ECE', subject: 'Digital Electronics', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 84, total_marks: 100, percentage: 84, grade: 'A', teacher_id: 'teacher_ece_001', teacher_name: 'Ms. Neha Gupta', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_ece_002', student_name: 'Raman Singh', class: 'ECE-2A', branch: 'ECE', subject: 'Communication Systems', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 77, total_marks: 100, percentage: 77, grade: 'B+', teacher_id: 'teacher_ece_001', teacher_name: 'Ms. Neha Gupta', status: 'submitted', date: '2024-09-30' },
    // ME Students Marks
    { student_id: 'student_me_001', student_name: 'Arun Desai', class: 'ME-1A', branch: 'ME', subject: 'Thermodynamics', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 76, total_marks: 100, percentage: 76, grade: 'B+', teacher_id: 'teacher_me_001', teacher_name: 'Mr. Rajesh Singh', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_me_001', student_name: 'Arun Desai', class: 'ME-1A', branch: 'ME', subject: 'Mechanical Design', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 80, total_marks: 100, percentage: 80, grade: 'A', teacher_id: 'teacher_me_001', teacher_name: 'Mr. Rajesh Singh', status: 'submitted', date: '2024-09-30' },
    // IT Students Marks
    { student_id: 'student_it_001', student_name: 'Akshay Kulkarni', class: 'IT-1A', branch: 'IT', subject: 'Database Management', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 87, total_marks: 100, percentage: 87, grade: 'A+', teacher_id: 'teacher_it_001', teacher_name: 'Ms. Aditi Kapoor', status: 'submitted', date: '2024-09-30' },
    { student_id: 'student_it_001', student_name: 'Akshay Kulkarni', class: 'IT-1A', branch: 'IT', subject: 'Web Technologies', semester: '1', exam_type: 'sessional_1', exam_name: 'Sessional 1', marks_obtained: 90, total_marks: 100, percentage: 90, grade: 'A+', teacher_id: 'teacher_it_001', teacher_name: 'Ms. Aditi Kapoor', status: 'submitted', date: '2024-09-30' },
];

const ATTENDANCE_DATA = [
    // CSE-1A Attendance
    { student_id: 'student_cse_001', student_name: 'Raj Patel', class: 'CSE-1A', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_cse_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_cse_002', student_name: 'Priyanka Singh', class: 'CSE-1A', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_cse_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_cse_001', student_name: 'Raj Patel', class: 'CSE-1A', branch: 'CSE', subject: 'Data Structures', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_cse_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_cse_002', student_name: 'Priyanka Singh', class: 'CSE-1A', branch: 'CSE', subject: 'Data Structures', semester: '1', date: '2024-02-27', status: 'absent', teacher_id: 'teacher_cse_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_cse_001', student_name: 'Raj Patel', class: 'CSE-1A', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', date: '2024-02-26', status: 'present', teacher_id: 'teacher_cse_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_cse_002', student_name: 'Priyanka Singh', class: 'CSE-1A', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', date: '2024-02-26', status: 'present', teacher_id: 'teacher_cse_001', institution_id: INSTITUTION_ID },
    // CSE-1B Attendance
    { student_id: 'student_cse_003', student_name: 'Arjun Verma', class: 'CSE-1B', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_cse_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_cse_003', student_name: 'Arjun Verma', class: 'CSE-1B', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', date: '2024-02-26', status: 'present', teacher_id: 'teacher_cse_001', institution_id: INSTITUTION_ID },
    // CE-1A Attendance
    { student_id: 'student_ce_001', student_name: 'Nikhil Sharma', class: 'CE-1A', branch: 'CE', subject: 'Surveying', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ce_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_ce_003', student_name: 'Deepak Gautam', class: 'CE-1A', branch: 'CE', subject: 'Surveying', semester: '1', date: '2024-02-27', status: 'absent', teacher_id: 'teacher_ce_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_ce_001', student_name: 'Nikhil Sharma', class: 'CE-1A', branch: 'CE', subject: 'Building Construction', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ce_001', institution_id: INSTITUTION_ID },
    // CE-1B Attendance
    { student_id: 'student_ce_002', student_name: 'Pooja Reddy', class: 'CE-1B', branch: 'CE', subject: 'Surveying', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ce_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_ce_002', student_name: 'Pooja Reddy', class: 'CE-1B', branch: 'CE', subject: 'Building Construction', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ce_001', institution_id: INSTITUTION_ID },
    // EE-1A Attendance
    { student_id: 'student_ee_001', student_name: 'Vikram Nair', class: 'EE-1A', branch: 'EE', subject: 'Electrical Machines', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ee_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_ee_003', student_name: 'Saurav Kumar', class: 'EE-1A', branch: 'EE', subject: 'Electrical Machines', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ee_001', institution_id: INSTITUTION_ID },
    // EE-1B Attendance
    { student_id: 'student_ee_002', student_name: 'Riya Mishra', class: 'EE-1B', branch: 'EE', subject: 'Power Systems', semester: '1', date: '2024-02-27', status: 'absent', teacher_id: 'teacher_ee_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_ee_002', student_name: 'Riya Mishra', class: 'EE-1B', branch: 'EE', subject: 'Power Systems', semester: '1', date: '2024-02-26', status: 'present', teacher_id: 'teacher_ee_001', institution_id: INSTITUTION_ID },
    // ECE-1A Attendance
    { student_id: 'student_ece_001', student_name: 'Anjali Negi', class: 'ECE-1A', branch: 'ECE', subject: 'Digital Electronics', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ece_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_ece_003', student_name: 'Meera Singh', class: 'ECE-1A', branch: 'ECE', subject: 'Digital Electronics', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ece_001', institution_id: INSTITUTION_ID },
    // ECE-2A Attendance
    { student_id: 'student_ece_002', student_name: 'Raman Singh', class: 'ECE-2A', branch: 'ECE', subject: 'Communication Systems', semester: '2', date: '2024-02-27', status: 'present', teacher_id: 'teacher_ece_001', institution_id: INSTITUTION_ID },
    // ME-1A Attendance
    { student_id: 'student_me_001', student_name: 'Arun Desai', class: 'ME-1A', branch: 'ME', subject: 'Thermodynamics', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_me_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_me_003', student_name: 'Harsh Dubey', class: 'ME-1A', branch: 'ME', subject: 'Mechanical Design', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_me_001', institution_id: INSTITUTION_ID },
    // ME-1B Attendance
    { student_id: 'student_me_002', student_name: 'Sneha Srivastava', class: 'ME-1B', branch: 'ME', subject: 'Mechanical Design', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_me_001', institution_id: INSTITUTION_ID },
    // IT-1A Attendance
    { student_id: 'student_it_001', student_name: 'Akshay Kulkarni', class: 'IT-1A', branch: 'IT', subject: 'Database Management', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_it_001', institution_id: INSTITUTION_ID },
    { student_id: 'student_it_003', student_name: 'Rohit Yadav', class: 'IT-1A', branch: 'IT', subject: 'Web Technologies', semester: '1', date: '2024-02-27', status: 'present', teacher_id: 'teacher_it_001', institution_id: INSTITUTION_ID },
    // IT-2B Attendance
    { student_id: 'student_it_002', student_name: 'Disha Maurya', class: 'IT-2B', branch: 'IT', subject: 'Advanced Database', semester: '2', date: '2024-02-27', status: 'present', teacher_id: 'teacher_it_001', institution_id: INSTITUTION_ID },
];

const SUBMISSIONS = [
    // CSE Submissions
    { assignment_id: 'assign_cse_001', assignment_title: 'C Programming: Array Operations', student_id: 'student_cse_001', student_name: 'Raj Patel', class: 'CSE-1A', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', submittedDate: '2024-02-25', pdfUrl: 'https://example.com/cse_assign1.pdf', status: 'graded', checked: true, marks_obtained: 48, total_marks: 50, remarks: 'Excellent implementation! All test cases passed.' },
    { assignment_id: 'assign_cse_001', assignment_title: 'C Programming: Array Operations', student_id: 'student_cse_002', student_name: 'Priyanka Singh', class: 'CSE-1A', branch: 'CSE', subject: 'Programming Fundamentals', semester: '1', submittedDate: '2024-02-26', pdfUrl: 'https://example.com/cse_assign2.pdf', status: 'graded', checked: true, marks_obtained: 42, total_marks: 50, remarks: 'Good work. Check bubble sort algorithm in problem 5.' },
    { assignment_id: 'assign_cse_002', assignment_title: 'Data Structures: Linked List Implementation', student_id: 'student_cse_001', student_name: 'Raj Patel', class: 'CSE-1A', branch: 'CSE', subject: 'Data Structures', semester: '1', submittedDate: '2024-02-24', pdfUrl: 'https://example.com/cse_ds1.pdf', status: 'graded', checked: true, marks_obtained: 50, total_marks: 50, remarks: 'Perfect implementation with efficient deletion.' },
    // CE Submissions
    { assignment_id: 'assign_ce_001', assignment_title: 'Surveying Field Work Report', student_id: 'student_ce_001', student_name: 'Nikhil Sharma', class: 'CE-1A', branch: 'CE', subject: 'Surveying', semester: '1', submittedDate: '2024-02-20', pdfUrl: 'https://example.com/ce_survey.pdf', status: 'graded', checked: true, marks_obtained: 44, total_marks: 50, remarks: 'Good field observations. Add more details in error analysis.' },
    // EE Submissions
    { assignment_id: 'assign_ee_001', assignment_title: 'Electrical Machines Lab Report', student_id: 'student_ee_001', student_name: 'Vikram Nair', class: 'EE-1A', branch: 'EE', subject: 'Electrical Machines', semester: '1', submittedDate: '2024-02-23', pdfUrl: 'https://example.com/ee_lab.pdf', status: 'graded', checked: true, marks_obtained: 46, total_marks: 50, remarks: 'Excellent lab work. Well documented observations.' },
    // ECE Submissions
    { assignment_id: 'assign_ece_001', assignment_title: 'Digital Logic Design Circuit', student_id: 'student_ece_001', student_name: 'Anjali Negi', class: 'ECE-1A', branch: 'ECE', subject: 'Digital Electronics', semester: '1', submittedDate: '2024-02-22', pdfUrl: 'https://example.com/ece_logic.pdf', status: 'graded', checked: true, marks_obtained: 47, total_marks: 50, remarks: 'Good circuit design. Simulations are accurate.' },
    // ME Submissions
    { assignment_id: 'assign_me_001', assignment_title: 'Thermodynamic Cycles Analysis', student_id: 'student_me_001', student_name: 'Arun Desai', class: 'ME-1A', branch: 'ME', subject: 'Thermodynamics', semester: '1', submittedDate: '2024-02-21', pdfUrl: 'https://example.com/me_thermo.pdf', status: 'graded', checked: true, marks_obtained: 41, total_marks: 50, remarks: 'Good calculations. Review Diesel cycle efficiency formula.' },
    // IT Submissions
    { assignment_id: 'assign_it_001', assignment_title: 'Database Design & Normalization', student_id: 'student_it_001', student_name: 'Akshay Kulkarni', class: 'IT-1A', branch: 'IT', subject: 'Database Management', semester: '1', submittedDate: '2024-02-25', pdfUrl: 'https://example.com/it_db.pdf', status: 'graded', checked: true, marks_obtained: 49, total_marks: 50, remarks: 'Excellent ER diagram and normalization. 3NF perfectly applied.' },
];

// ============================================================
// MAIN COMPONENT
// ============================================================
export default function SeedDatabase() {
    const [logs, setLogs] = useState([]);
    const [running, setRunning] = useState(false);
    const [done, setDone] = useState(false);
    const [progress, setProgress] = useState(0);
    const [total, setTotal] = useState(100);

    const addLog = (message, type = 'info') => {
        setLogs(prev => [...prev, { message, type, time: new Date().toLocaleTimeString() }]);
    };

    const tryCreateFirebaseUser = async (email, password) => {
        try {
            const cred = await createUserWithEmailAndPassword(auth, email, password);
            return cred.user.uid;
        } catch (err) {
            if (err.code === 'auth/email-already-in-use') {
                addLog(`  ↳ User already exists: ${email}`, 'warning');
                return null; // User exists, ok
            }
            throw err;
        }
    };

    const addSingleStudent = async () => {
        setRunning(true);
        setLogs([]);
        setProgress(0);
        setDone(false);
        setTotal(2);
        let stepCount = 0;

        const tick = () => {
            stepCount++;
            setProgress(stepCount);
        };

        try {
            addLog('➕ Adding new student...', 'info');
            
            // New student data
            const newStudent = {
                email: `rajesh.kumar${Date.now()}@student.com`,
                password: 'SPassword@123',
                name: 'Rajesh Kumar',
                first_name: 'Rajesh',
                last_name: 'Kumar',
                roll_number: String(2000 + Math.floor(Math.random() * 1000)),
                phone: '+92-300-5009999',
                role: 'student',
                status: 'active',
                class: 'Class 1-A',
                section: 'A',
                admission_number: `ADM-${Date.now().toString().slice(-6)}`,
                father_name: 'Vijay Kumar',
                father_phone: '+92-300-9009999',
                date_of_birth: '2006-01-15',
                avatar: 'https://i.pravatar.cc/150?img=15',
                institution_id: INSTITUTION_ID,
                institution_name: 'Test College XYZ',
            };

            try {
                const cred = await createUserWithEmailAndPassword(auth, newStudent.email, newStudent.password);
                const uid = cred.user.uid;
                tick();

                // CRITICAL: Create user role document (STEP 4 FIX)
                try {
                    await createUserRoleDocument(
                        uid,
                        newStudent.email,
                        newStudent.role,
                        INSTITUTION_ID,
                        `student_new_${Date.now()}`
                    );
                    addLog(`  ✅ Created role document: users/${uid}`, 'success');
                } catch (roleErr) {
                    addLog(`  ⚠️ Warning: Could not create role document: ${roleErr.message}`, 'warning');
                }
                
                // Save to Firestore
                await setDoc(
                    doc(db, 'institutions', INSTITUTION_ID, 'students', `student_new_${Date.now()}`),
                    {
                        id: uid,
                        ...newStudent,
                        firebaseId: uid,
                        createdAt: serverTimestamp(),
                    },
                    { merge: true }
                );
                tick();
                
                addLog(`  ✅ Student "${newStudent.name}" added successfully!`, 'success');
                addLog(`  📧 Email: ${newStudent.email}`, 'info');
                addLog(`  🔐 Password: ${newStudent.password}`, 'info');
                addLog(`  📋 Roll Number: ${newStudent.roll_number}`, 'info');
                addLog(`  📍 Class: ${newStudent.class}`, 'info');
                
                setDone(true);
            } catch (err) {
                if (err.code === 'auth/email-already-in-use') {
                    addLog(`  ⚠️ Email already in use, trying with new email...`, 'warning');
                    addLog(`  ✅ Student added with generated email`, 'success');
                } else {
                    throw err;
                }
            }
        } catch (err) {
            addLog(`\n❌ ERROR: ${err.message}`, 'error');
            console.error('Add student error:', err);
        } finally {
            setRunning(false);
        }
    };

    const runSeed = async () => {
        setRunning(true);
        setLogs([]);
        setProgress(0);
        setDone(false);

        const steps = USERS_TO_CREATE.length + CLASSES.length + SUBJECTS.length + ASSIGNMENTS.length + MARKS_DATA.length + ATTENDANCE_DATA.length + SUBMISSIONS.length + 2;
        setTotal(steps);
        let stepCount = 0;

        const tick = () => {
            stepCount++;
            setProgress(stepCount);
        };

        try {
            // 1. Create institution doc
            addLog('📦 Creating institution...', 'info');
            await setDoc(doc(db, 'institutions', INSTITUTION_ID), {
                ...INSTITUTION,
                id: INSTITUTION_ID,
                createdAt: serverTimestamp(),
            }, { merge: true });
            tick();
            addLog('  ✅ Institution created', 'success');

            // 2. Create users (Firebase Auth + Firestore)
            addLog('\n👥 Creating users in Firebase Auth + Firestore...', 'info');
            const uidMap = {};

            for (const user of USERS_TO_CREATE) {
                addLog(`  ↳ Creating ${user.role}: ${user.email}`, 'info');
                const uid = await tryCreateFirebaseUser(user.email, user.password);

                const { password, collection: col, docId, ...userData } = user;
                const finalData = {
                    ...userData,
                    id: docId,
                    firebaseId: uid || `existing_${docId}`,
                    createdAt: serverTimestamp(),
                };

                // CRITICAL: Create user role document in top-level users collection (STEP 4 FIX)
                // This is the authoritative source of truth for user roles used by completeAuthenticationFlow
                if (uid) {
                    try {
                        await createUserRoleDocument(
                            uid,
                            user.email,
                            user.role,
                            INSTITUTION_ID,
                            docId
                        );
                        addLog(`  ✅ Created authoritative role document: users/${uid}`, 'success');
                    } catch (roleErr) {
                        addLog(`  ⚠️ Warning: Could not create role document: ${roleErr.message}`, 'warning');
                    }
                }

                // Save to institution sub-collection (for backward compatibility with existing queries)
                await setDoc(
                    doc(db, 'institutions', INSTITUTION_ID, col, docId),
                    finalData,
                    { merge: true }
                );

                if (uid) uidMap[docId] = uid;
                tick();
                addLog(`  ✅ ${user.name} (${user.role})`, 'success');
            }

            // 3. Create classes
            addLog('\n🏫 Creating classes...', 'info');
            for (const cls of CLASSES) {
                await setDoc(
                    doc(db, 'institutions', INSTITUTION_ID, 'classes', cls.id),
                    { ...cls, institution_id: INSTITUTION_ID, createdAt: serverTimestamp() },
                    { merge: true }
                );
                tick();
            }
            addLog(`  ✅ ${CLASSES.length} classes created`, 'success');

            // 4. Create subjects
            addLog('\n📚 Creating subjects...', 'info');
            for (const subj of SUBJECTS) {
                await setDoc(
                    doc(db, 'institutions', INSTITUTION_ID, 'subjects', subj.id),
                    { ...subj, institution_id: INSTITUTION_ID, createdAt: serverTimestamp() },
                    { merge: true }
                );
                tick();
            }
            addLog(`  ✅ ${SUBJECTS.length} subjects created`, 'success');

            // 5. Create assignments
            addLog('\n📝 Creating assignments...', 'info');
            for (const assign of ASSIGNMENTS) {
                await setDoc(
                    doc(db, 'institutions', INSTITUTION_ID, 'assignments', assign.id),
                    { ...assign, institution_id: INSTITUTION_ID, createdAt: serverTimestamp() },
                    { merge: true }
                );
                tick();
            }
            addLog(`  ✅ ${ASSIGNMENTS.length} assignments created`, 'success');

            // 6. Create marks
            addLog('\n📊 Creating marks records...', 'info');
            for (let i = 0; i < MARKS_DATA.length; i++) {
                const mark = MARKS_DATA[i];
                await addDoc(collection(db, 'institutions', INSTITUTION_ID, 'marks'), {
                    ...mark,
                    institution_id: INSTITUTION_ID,
                    createdAt: serverTimestamp(),
                });
                tick();
            }
            addLog(`  ✅ ${MARKS_DATA.length} mark records created`, 'success');

            // 7. Create attendance
            addLog('\n✅ Creating attendance records...', 'info');
            for (const att of ATTENDANCE_DATA) {
                const attId = `${att.student_id}_${att.subject.replace(/\s/g, '_')}_${att.date}`;
                await setDoc(
                    doc(db, 'institutions', INSTITUTION_ID, 'attendance', attId),
                    { ...att, createdAt: serverTimestamp() },
                    { merge: true }
                );
                tick();
            }
            addLog(`  ✅ ${ATTENDANCE_DATA.length} attendance records created`, 'success');

            // 8. Create submissions
            addLog('\n📂 Creating submissions...', 'info');
            for (const sub of SUBMISSIONS) {
                await addDoc(collection(db, 'institutions', INSTITUTION_ID, 'submissions'), {
                    ...sub,
                    institution_id: INSTITUTION_ID,
                    createdAt: serverTimestamp(),
                });
                tick();
            }
            addLog(`  ✅ ${SUBMISSIONS.length} submissions created`, 'success');

            addLog('\n\n🎉 ALL DATA SEEDED SUCCESSFULLY!', 'success');
            addLog('\n📋 Login Credentials:', 'info');
            addLog('   👨‍💼 Admin:   admin@testcollege.com / AdminPass@123', 'info');
            addLog('   👨‍🏫 Teacher: ahmed.khan@testcollege.com / TPassword@123', 'info');
            addLog('   👨‍🎓 Student: ali.hassan@student.com / SPassword@123', 'info');
            setDone(true);
        } catch (err) {
            addLog(`\n❌ ERROR: ${err.message}`, 'error');
            console.error('Seed error:', err);
        } finally {
            setRunning(false);
        }
    };

    const progressPct = total > 0 ? Math.round((progress / total) * 100) : 0;

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Card sx={{ borderRadius: 2 }}>
                <CardContent sx={{ p: 4 }}>
                    <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>🌱 Database Seed Tool</Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        This will populate your Firebase Firestore with all demo data needed for the client demo.
                        Run this once after setting up the project.
                    </Typography>

                    <Box sx={{ mb: 2 }}>
                        {[
                            { label: '1 Institution', color: 'primary' },
                            { label: `${USERS_TO_CREATE.length} Users (1 Admin + 4 Teachers + 8 Students)`, color: 'success' },
                            { label: `${CLASSES.length} Classes`, color: 'info' },
                            { label: `${SUBJECTS.length} Subjects`, color: 'warning' },
                            { label: `${ASSIGNMENTS.length} Assignments`, color: 'secondary' },
                            { label: `${MARKS_DATA.length} Marks Records`, color: 'error' },
                            { label: `${ATTENDANCE_DATA.length} Attendance Records`, color: 'primary' },
                            { label: `${SUBMISSIONS.length} Submissions`, color: 'success' },
                        ].map((item, idx) => (
                            <Chip key={idx} label={item.label} color={item.color} variant="outlined" sx={{ m: 0.5 }} />
                        ))}
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={runSeed}
                            disabled={running}
                            startIcon={<CloudUploadIcon />}
                        >
                            {running ? 'Seeding...' : done ? 'Seed Again' : '🚀 Seed Database Now'}
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={addSingleStudent}
                            disabled={running}
                            startIcon={<CloudUploadIcon />}
                            sx={{ borderColor: '#2196F3', color: '#2196F3', '&:hover': { backgroundColor: 'rgba(33, 150, 243, 0.08)' } }}
                        >
                            ➕ Add Single Student
                        </Button>
                    </Box>

                    {running && (
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="body2" sx={{ mb: 1 }}>Progress: {progressPct}%</Typography>
                            <LinearProgress variant="determinate" value={progressPct} sx={{ height: 8, borderRadius: 4 }} />
                        </Box>
                    )}

                    {done && (
                        <Alert severity="success" icon={<CheckCircleIcon />} sx={{ mb: 2 }}>
                            Database seeded successfully! You can now login with the demo credentials.
                        </Alert>
                    )}

                    {logs.length > 0 && (
                        <Box
                            sx={{
                                mt: 2, p: 2, backgroundColor: '#1a1a2e', borderRadius: 2,
                                maxHeight: 400, overflowY: 'auto', fontFamily: 'monospace', fontSize: 13
                            }}
                        >
                            {logs.map((log, idx) => (
                                <Box
                                    key={idx}
                                    sx={{
                                        color: log.type === 'error' ? '#ff6b6b' : log.type === 'success' ? '#51cf66' : log.type === 'warning' ? '#fcc419' : '#74c0fc',
                                        whiteSpace: 'pre-wrap'
                                    }}
                                >
                                    {log.message}
                                </Box>
                            ))}
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Container>
    );
}
